import { render, staticRenderFns } from "./CorporateScheduledEmail.vue?vue&type=template&id=173bf6c7&scoped=true&"
import script from "./CorporateScheduledEmail.vue?vue&type=script&lang=js&"
export * from "./CorporateScheduledEmail.vue?vue&type=script&lang=js&"
import style0 from "./CorporateScheduledEmail.vue?vue&type=style&index=0&id=173bf6c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bf6c7",
  null
  
)

export default component.exports